import './App.scss';
import { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Header from './Header/Header';

const Home = lazy(() => import('./Home/Home'));
const PartSearch = lazy(() => import('./PartSearch/PartSearch'));
const AvailableParts = lazy(() => import('./AvailableParts/AvailableParts'));
const AvailablePartDetail = lazy(() => import('./AvailableParts/AvailablePartDetail'));
const CarSell = lazy(() => import('./CarSell/CarSell'));
const Contact = lazy(() => import('./Contact/Contact'));
const Profession = lazy(() => import('./Profession/Profession'));
const Privacy = lazy(() => import('./Privacy/Privacy'));
const OrderPage = lazy(() => import('./Order/OrderPage'));
const TransferReturnPage = lazy(() => import('./Order/TransferReturnPage'));
const WithdrawalPage = lazy(() => import('./Withdrawal/WithdrawalPage'));
const CgvPage = lazy(() => import('./Legal/CgvPage'));
const LegalNotice = lazy(() => import('./Legal/LegalNotice'));
const NotFound = lazy(() => import('./NotFound/NotFound'));

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header/>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" exact element={<Home/>} />
          <Route path="/part-search" element={<PartSearch/>} />
          <Route path="/available-parts" element={<AvailableParts/>} />
          <Route path="/available-parts/:partId" element={<AvailablePartDetail/>} />
          <Route path="/car-sell" element={<CarSell/>} />
          <Route path="/profession" element={<Profession/>} />
          <Route path="/contact" element={<Contact/>} />
          <Route path="/politique-de-confidentialite" element={<Privacy/>} />
          <Route path="/commande/:partId" element={<OrderPage/>} />
          <Route path="/paiement/retour-virement" element={<TransferReturnPage/>} />
          <Route path="/retractation" element={<WithdrawalPage/>} />
          <Route path="/cgv" element={<CgvPage/>} />
          <Route path="/mentions-legales" element={<LegalNotice/>} />
          <Route path="*" element={<NotFound/>} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
